export const inputTypes = {
    text: {label: 'Texto Simples'},
    largetext: {label: 'Texto Longo'},
    select: {label: 'Menu de Seleção'},
    option: {label: 'Menu de Opções '},
    checkbox: {label: 'Marcação/Checkbox'},
    date: {label: 'Data'},
    datetime: {label: 'Data e Hora'}
}
